import React from "react";
import { Box, Paper } from "@material-ui/core";
import { Warning } from "@material-ui/icons";

const DeletedExerciseWarning: React.FC = () => {
  return (
    <Paper
      elevation={0}
      style={{
        backgroundColor: "#fff3cd",
        border: "1px solid #ffc107",
        padding: "16px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <Warning style={{ color: "#ff9800", fontSize: "24px" }} />
      <Box style={{ color: "#856404", fontWeight: 500 }}>
        This exercise has been soft deleted, it will not be seen in the exercise list
      </Box>
    </Paper>
  );
};

export default DeletedExerciseWarning;
